import { TranslateService } from '@ngx-translate/core';

export const getTranslatedTime = (unit: string, value: number, translateService: TranslateService): string => {
    const singular = translateService.instant(`${unit}`);
    const plural = translateService.instant(`${unit}_pluriel`);
    const label = value === 1 ? singular : plural;
    return `il y a ${value} ${label}`;
};